export default {"src":"/_next/static/media/BFAM.1035fae6.svg","height":18,"width":18};